// Generated from testdata/qa/auto269/village-names.json for the frozen village catalogue.
export type VillageNameEntry = { id: number; biome: string; nameKey: string; en: string; ru: string };
export const VILLAGE_NAME_ENTRIES: readonly VillageNameEntry[] = [
  {
    "id": 4,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.4.v1",
    "en": "Greenbrook",
    "ru": "Зелёный Ручей"
  },
  {
    "id": 11,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.11.v1",
    "en": "Briarhollow",
    "ru": "Терновая Лощина"
  },
  {
    "id": 13,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.13.v1",
    "en": "Sunwell",
    "ru": "Солнечный Ключ"
  },
  {
    "id": 15,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.15.v1",
    "en": "Redstone",
    "ru": "Красные Камни"
  },
  {
    "id": 19,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.19.v1",
    "en": "Reedford",
    "ru": "Камышовый Брод"
  },
  {
    "id": 26,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.26.v1",
    "en": "Ashwell",
    "ru": "Пепельный Ключ"
  },
  {
    "id": 27,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.27.v1",
    "en": "Willowfen",
    "ru": "Ивовый Мыс"
  },
  {
    "id": 32,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.32.v1",
    "en": "Sandford",
    "ru": "Песчаный Брод"
  },
  {
    "id": 37,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.37.v1",
    "en": "Mosswater",
    "ru": "Моховой Ручей"
  },
  {
    "id": 47,
    "biome": "volcanic",
    "nameKey": "poi.village.auto269.47.v1",
    "en": "Cinderstead",
    "ru": "Пепельный Стан"
  },
  {
    "id": 52,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.52.v1",
    "en": "Ryehill",
    "ru": "Ржаной Холм"
  },
  {
    "id": 54,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.54.v1",
    "en": "Lindenford",
    "ru": "Липовый Брод"
  },
  {
    "id": 55,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.55.v1",
    "en": "Lindenwell",
    "ru": "Липовый Ключ"
  },
  {
    "id": 56,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.56.v1",
    "en": "Lindenbrook",
    "ru": "Липовый Ручей"
  },
  {
    "id": 57,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.57.v1",
    "en": "Sandwell",
    "ru": "Песчаный Ключ"
  },
  {
    "id": 58,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.58.v1",
    "en": "Lindenbank",
    "ru": "Липовый Берег"
  },
  {
    "id": 59,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.59.v1",
    "en": "Lindenreach",
    "ru": "Липовый Мыс"
  },
  {
    "id": 60,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.60.v1",
    "en": "Lindenhill",
    "ru": "Липовый Холм"
  },
  {
    "id": 61,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.61.v1",
    "en": "Cloverford",
    "ru": "Клеверный Брод"
  },
  {
    "id": 62,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.62.v1",
    "en": "Cloverwell",
    "ru": "Клеверный Ключ"
  },
  {
    "id": 63,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.63.v1",
    "en": "Cloverbrook",
    "ru": "Клеверный Ручей"
  },
  {
    "id": 64,
    "biome": "forest",
    "nameKey": "poi.village.auto269.64.v1",
    "en": "Pineford",
    "ru": "Сосновый Брод"
  },
  {
    "id": 65,
    "biome": "forest",
    "nameKey": "poi.village.auto269.65.v1",
    "en": "Pinewell",
    "ru": "Сосновый Ключ"
  },
  {
    "id": 66,
    "biome": "forest",
    "nameKey": "poi.village.auto269.66.v1",
    "en": "Pinebrook",
    "ru": "Сосновый Ручей"
  },
  {
    "id": 67,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.67.v1",
    "en": "Cloverbank",
    "ru": "Клеверный Берег"
  },
  {
    "id": 68,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.68.v1",
    "en": "Stoneford",
    "ru": "Каменный Брод"
  },
  {
    "id": 69,
    "biome": "forest",
    "nameKey": "poi.village.auto269.69.v1",
    "en": "Pinebank",
    "ru": "Сосновый Берег"
  },
  {
    "id": 70,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.70.v1",
    "en": "Stonewell",
    "ru": "Каменный Ключ"
  },
  {
    "id": 71,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.71.v1",
    "en": "Stonebrook",
    "ru": "Каменный Ручей"
  },
  {
    "id": 72,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.72.v1",
    "en": "Stonebank",
    "ru": "Каменный Берег"
  },
  {
    "id": 73,
    "biome": "astral",
    "nameKey": "poi.village.auto269.73.v1",
    "en": "Starford",
    "ru": "Звёздный Брод"
  },
  {
    "id": 74,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.74.v1",
    "en": "Stonereach",
    "ru": "Каменный Мыс"
  },
  {
    "id": 75,
    "biome": "forest",
    "nameKey": "poi.village.auto269.75.v1",
    "en": "Pinereach",
    "ru": "Сосновый Мыс"
  },
  {
    "id": 76,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.76.v1",
    "en": "Sandbrook",
    "ru": "Песчаный Ручей"
  },
  {
    "id": 77,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.77.v1",
    "en": "Sandbank",
    "ru": "Песчаный Берег"
  },
  {
    "id": 78,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.78.v1",
    "en": "Sandreach",
    "ru": "Песчаный Мыс"
  },
  {
    "id": 79,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.79.v1",
    "en": "Alderford",
    "ru": "Ольховый Брод"
  },
  {
    "id": 80,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.80.v1",
    "en": "Sandhill",
    "ru": "Песчаный Холм"
  },
  {
    "id": 81,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.81.v1",
    "en": "Cloverreach",
    "ru": "Клеверный Мыс"
  },
  {
    "id": 82,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.82.v1",
    "en": "Clayford",
    "ru": "Глиняный Брод"
  },
  {
    "id": 83,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.83.v1",
    "en": "Claywell",
    "ru": "Глиняный Ключ"
  },
  {
    "id": 84,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.84.v1",
    "en": "Alderwell",
    "ru": "Ольховый Ключ"
  },
  {
    "id": 85,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.85.v1",
    "en": "Alderbrook",
    "ru": "Ольховый Ручей"
  },
  {
    "id": 86,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.86.v1",
    "en": "Alderbank",
    "ru": "Ольховый Берег"
  },
  {
    "id": 87,
    "biome": "forest",
    "nameKey": "poi.village.auto269.87.v1",
    "en": "Pinehill",
    "ru": "Сосновый Холм"
  },
  {
    "id": 88,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.88.v1",
    "en": "Alderreach",
    "ru": "Ольховый Мыс"
  },
  {
    "id": 89,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.89.v1",
    "en": "Stonehill",
    "ru": "Каменный Холм"
  },
  {
    "id": 90,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.90.v1",
    "en": "Ashford",
    "ru": "Пепельный Брод"
  },
  {
    "id": 91,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.91.v1",
    "en": "Ashbrook",
    "ru": "Пепельный Ручей"
  },
  {
    "id": 92,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.92.v1",
    "en": "Reedwell",
    "ru": "Камышовый Ключ"
  },
  {
    "id": 93,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.93.v1",
    "en": "Reedbrook",
    "ru": "Камышовый Ручей"
  },
  {
    "id": 94,
    "biome": "forest",
    "nameKey": "poi.village.auto269.94.v1",
    "en": "Spruceford",
    "ru": "Еловый Брод"
  },
  {
    "id": 95,
    "biome": "forest",
    "nameKey": "poi.village.auto269.95.v1",
    "en": "Sprucewell",
    "ru": "Еловый Ключ"
  },
  {
    "id": 96,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.96.v1",
    "en": "Reedbank",
    "ru": "Камышовый Берег"
  },
  {
    "id": 97,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.97.v1",
    "en": "Reedreach",
    "ru": "Камышовый Мыс"
  },
  {
    "id": 98,
    "biome": "volcanic",
    "nameKey": "poi.village.auto269.98.v1",
    "en": "Cinderford",
    "ru": "Зольный Брод"
  },
  {
    "id": 99,
    "biome": "volcanic",
    "nameKey": "poi.village.auto269.99.v1",
    "en": "Cinderwell",
    "ru": "Зольный Ключ"
  },
  {
    "id": 100,
    "biome": "astral",
    "nameKey": "poi.village.auto269.100.v1",
    "en": "Starwell",
    "ru": "Звёздный Ключ"
  },
  {
    "id": 101,
    "biome": "forest",
    "nameKey": "poi.village.auto269.101.v1",
    "en": "Sprucebrook",
    "ru": "Еловый Ручей"
  },
  {
    "id": 102,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.102.v1",
    "en": "Cloverhill",
    "ru": "Клеверный Холм"
  },
  {
    "id": 103,
    "biome": "forest",
    "nameKey": "poi.village.auto269.103.v1",
    "en": "Sprucebank",
    "ru": "Еловый Берег"
  },
  {
    "id": 104,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.104.v1",
    "en": "Appleford",
    "ru": "Яблоневый Брод"
  },
  {
    "id": 105,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.105.v1",
    "en": "Applewell",
    "ru": "Яблоневый Ключ"
  },
  {
    "id": 106,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.106.v1",
    "en": "Ashbank",
    "ru": "Пепельный Берег"
  },
  {
    "id": 107,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.107.v1",
    "en": "Sedgeford",
    "ru": "Осоковый Брод"
  },
  {
    "id": 108,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.108.v1",
    "en": "Sedgewell",
    "ru": "Осоковый Ключ"
  },
  {
    "id": 109,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.109.v1",
    "en": "Sedgebrook",
    "ru": "Осоковый Ручей"
  },
  {
    "id": 110,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.110.v1",
    "en": "Sedgebank",
    "ru": "Осоковый Берег"
  },
  {
    "id": 111,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.111.v1",
    "en": "Sedgereach",
    "ru": "Осоковый Мыс"
  },
  {
    "id": 112,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.112.v1",
    "en": "Willowford",
    "ru": "Ивовый Брод"
  },
  {
    "id": 113,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.113.v1",
    "en": "Applebrook",
    "ru": "Яблоневый Ручей"
  },
  {
    "id": 114,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.114.v1",
    "en": "Applebank",
    "ru": "Яблоневый Берег"
  },
  {
    "id": 115,
    "biome": "forest",
    "nameKey": "poi.village.auto269.115.v1",
    "en": "Sprucereach",
    "ru": "Еловый Мыс"
  },
  {
    "id": 116,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.116.v1",
    "en": "Applereach",
    "ru": "Яблоневый Мыс"
  },
  {
    "id": 117,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.117.v1",
    "en": "Claybrook",
    "ru": "Глиняный Ручей"
  },
  {
    "id": 118,
    "biome": "forest",
    "nameKey": "poi.village.auto269.118.v1",
    "en": "Sprucehill",
    "ru": "Еловый Холм"
  },
  {
    "id": 119,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.119.v1",
    "en": "Ashreach",
    "ru": "Пепельный Мыс"
  },
  {
    "id": 120,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.120.v1",
    "en": "Ashhill",
    "ru": "Пепельный Холм"
  },
  {
    "id": 121,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.121.v1",
    "en": "Oldford",
    "ru": "Старый Брод"
  },
  {
    "id": 122,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.122.v1",
    "en": "Applehill",
    "ru": "Яблоневый Холм"
  },
  {
    "id": 123,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.123.v1",
    "en": "Claybank",
    "ru": "Глиняный Берег"
  },
  {
    "id": 124,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.124.v1",
    "en": "Clayreach",
    "ru": "Глиняный Мыс"
  },
  {
    "id": 125,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.125.v1",
    "en": "Honeyford",
    "ru": "Медовый Брод"
  },
  {
    "id": 126,
    "biome": "astral",
    "nameKey": "poi.village.auto269.126.v1",
    "en": "Starbrook",
    "ru": "Звёздный Ручей"
  },
  {
    "id": 127,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.127.v1",
    "en": "Willowwell",
    "ru": "Ивовый Ключ"
  },
  {
    "id": 128,
    "biome": "astral",
    "nameKey": "poi.village.auto269.128.v1",
    "en": "Starbank",
    "ru": "Звёздный Берег"
  },
  {
    "id": 129,
    "biome": "forest",
    "nameKey": "poi.village.auto269.129.v1",
    "en": "Oakford",
    "ru": "Дубовый Брод"
  },
  {
    "id": 130,
    "biome": "forest",
    "nameKey": "poi.village.auto269.130.v1",
    "en": "Oakwell",
    "ru": "Дубовый Ключ"
  },
  {
    "id": 131,
    "biome": "forest",
    "nameKey": "poi.village.auto269.131.v1",
    "en": "Oakbrook",
    "ru": "Дубовый Ручей"
  },
  {
    "id": 132,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.132.v1",
    "en": "Clayhill",
    "ru": "Глиняный Холм"
  },
  {
    "id": 133,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.133.v1",
    "en": "Copperford",
    "ru": "Медный Брод"
  },
  {
    "id": 134,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.134.v1",
    "en": "Copperwell",
    "ru": "Медный Ключ"
  },
  {
    "id": 135,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.135.v1",
    "en": "Willowbrook",
    "ru": "Ивовый Ручей"
  },
  {
    "id": 136,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.136.v1",
    "en": "Willowbank",
    "ru": "Ивовый Берег"
  },
  {
    "id": 137,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.137.v1",
    "en": "Heronford",
    "ru": "Цапельный Брод"
  },
  {
    "id": 138,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.138.v1",
    "en": "Oldwell",
    "ru": "Старый Ключ"
  },
  {
    "id": 139,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.139.v1",
    "en": "Oldbrook",
    "ru": "Старый Ручей"
  },
  {
    "id": 140,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.140.v1",
    "en": "Oldbank",
    "ru": "Старый Берег"
  },
  {
    "id": 141,
    "biome": "forest",
    "nameKey": "poi.village.auto269.141.v1",
    "en": "Oakbank",
    "ru": "Дубовый Берег"
  },
  {
    "id": 142,
    "biome": "forest",
    "nameKey": "poi.village.auto269.142.v1",
    "en": "Oakreach",
    "ru": "Дубовый Мыс"
  },
  {
    "id": 143,
    "biome": "swamp",
    "nameKey": "poi.village.auto269.143.v1",
    "en": "Heronwell",
    "ru": "Цапельный Ключ"
  },
  {
    "id": 144,
    "biome": "volcanic",
    "nameKey": "poi.village.auto269.144.v1",
    "en": "Cinderbrook",
    "ru": "Зольный Ручей"
  },
  {
    "id": 145,
    "biome": "volcanic",
    "nameKey": "poi.village.auto269.145.v1",
    "en": "Cinderbank",
    "ru": "Зольный Берег"
  },
  {
    "id": 146,
    "biome": "forest",
    "nameKey": "poi.village.auto269.146.v1",
    "en": "Oakhill",
    "ru": "Дубовый Холм"
  },
  {
    "id": 147,
    "biome": "forest",
    "nameKey": "poi.village.auto269.147.v1",
    "en": "Rowanford",
    "ru": "Рябиновый Брод"
  },
  {
    "id": 148,
    "biome": "forest",
    "nameKey": "poi.village.auto269.148.v1",
    "en": "Rowanwell",
    "ru": "Рябиновый Ключ"
  },
  {
    "id": 149,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.149.v1",
    "en": "Honeywell",
    "ru": "Медовый Ключ"
  },
  {
    "id": 150,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.150.v1",
    "en": "Honeybrook",
    "ru": "Медовый Ручей"
  },
  {
    "id": 151,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.151.v1",
    "en": "Oldreach",
    "ru": "Старый Мыс"
  },
  {
    "id": 152,
    "biome": "ruins",
    "nameKey": "poi.village.auto269.152.v1",
    "en": "Oldhill",
    "ru": "Старый Холм"
  },
  {
    "id": 153,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.153.v1",
    "en": "Copperbrook",
    "ru": "Медный Ручей"
  },
  {
    "id": 154,
    "biome": "canyon",
    "nameKey": "poi.village.auto269.154.v1",
    "en": "Copperbank",
    "ru": "Медный Берег"
  },
  {
    "id": 155,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.155.v1",
    "en": "Honeybank",
    "ru": "Медовый Берег"
  },
  {
    "id": 156,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.156.v1",
    "en": "Honeyreach",
    "ru": "Медовый Мыс"
  },
  {
    "id": 157,
    "biome": "astral",
    "nameKey": "poi.village.auto269.157.v1",
    "en": "Starreach",
    "ru": "Звёздный Мыс"
  },
  {
    "id": 158,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.158.v1",
    "en": "Honeyhill",
    "ru": "Медовый Холм"
  },
  {
    "id": 159,
    "biome": "meadow",
    "nameKey": "poi.village.auto269.159.v1",
    "en": "Oatford",
    "ru": "Овсяный Брод"
  }
];
export const VILLAGE_NAMES: Readonly<Record<string, { en: string; ru: string }>> = Object.fromEntries(VILLAGE_NAME_ENTRIES.map(({ nameKey, en, ru }) => [nameKey, { en, ru }]));
